import styled from 'styled-components';
import { Colors } from '../../../common/colors/colors';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	gap: 30px;
	padding: 30px;
	overflow-y: auto;
`;

export const SearchBar = styled.div`
	padding: 10px;
	display: flex;
	justify-content: center;
	flex-direction: column;
	color: ${Colors.darkBlue};
	border: 1px solid ${Colors.darkBlue};
	border-radius: 15px;
`;

export const Flex = styled.div`
	margin: 30px 0px;
	display: flex;
	justify-content: center;
`;

export const IconWrapper = styled.div`
	display: flex;
	gap: 10px;

	a {
		color: ${Colors.darkBlue};
		font-weight: bold;
		cursor: pointer;
	}
`;
